import { configureStore, combineReducers } from "@reduxjs/toolkit"
import globalReducer from "./reducer/GlobalReducer";
import assetsReducer from "./reducer/assets/AssetsReducer"
import dashboardReducer from "./reducer/dashboard/DashboardReducer"
import masterReducer from "./reducer/master/masterReducer"
import settingsReducer from "./reducer/settings/settingsReducer"
import usersReducer from "./reducer/users/usersReducer"
import maintenanceReducer from "./reducer/maintenance/maintenanceReducer"
import inventoryReducer from "./reducer/inventory/inventoryReducer"
import docReducer from "./reducer/doc/docReducer"
import reportReducer from "./reducer/report/reportReducer"

const rootReducer = combineReducers({
    ...globalReducer,
    ...assetsReducer,
    ...dashboardReducer,
    ...masterReducer,
    ...settingsReducer,
    ...usersReducer,
    ...maintenanceReducer,
    ...inventoryReducer,
    ...docReducer,
    ...reportReducer,
});

const rexo_asset_store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default rexo_asset_store;